<template lang="html">
  <div class="delete-wrapper">
    <div class="tabs">
      <!-- <span :class="{ active : active === 'deleteBlog' }" @click="active = 'deleteBlog'">Blog</span> -->
      <h2>{{ $t('admin.create.deleteBlog') }}</h2>
      </div>
    <keep-alive>
      <component :is="getActiveComponent" />
    </keep-alive>
  </div>
</template>

<script>
import deleteBlog from '@/components/admin/deleteBlog.vue'
export default {
  name: 'Delete',
  components: {
    deleteBlog
  },
  data () {
    return {
      active: 'deleteBlog'
    }
  },
  computed: {
    getActiveComponent () {
      return this.active
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-wrapper {
  text-align: left;
  .tabs {
    margin-bottom: 20px;
    span {
      margin-right: 20px;
      cursor: pointer;
    }
    span:last-child {
      margin-right: 0px;
    }
    span.active {
      color: var(--main-color);
    }
  }
}
</style>
